import React, { useContext } from "react"
import { Modal } from "react-bootstrap";
import { Button, InputLabel, TextField, MenuItem, Select } from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function EditProductModal({
  ShowModalEdit,
  setShowModalEdit,
  handleAddProducts,
  selectedProduct,
  grupoProdutos,
  putProducts,
  checkSaveBtn
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  return (
    <Modal show={ShowModalEdit} onHide={() => setShowModalEdit(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-row">
          <InputLabel className="d-flex flex-column me-1 w-50">
            {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.labels.produto}
            <TextField
              className="mb-3"
              name="prodGrupo_ProdCod"
              required
              fullWidth
              id="outlined-basic"
              placeholder="Nome do Produto"
              value={selectedProduct.prodGrupo_ProdCod}
              onChange={({ target }) => handleAddProducts(target, "EDIT_PRODUTO")}
            />
          </InputLabel>

          <InputLabel
            className="d-flex flex-column me-1 w-50"
          >
            {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.labels.grupo}
            <Select
              className=""
              value={selectedProduct.prodGrupo_GrupoNome}
              onChange={({ target }) => {
                handleAddProducts({
                  name: "prodGrupo_GrupoNome",
                  value: target.value
                }, "EDIT_PRODUTO")
              }}
            >
              {grupoProdutos.map((itemProd, i) => (
                <MenuItem
                  key={`grupProd-${itemProd.prodGrupo_GrupoNome}-${i}`}
                  value={itemProd.prodGrupo_GrupoNome}
                >
                  {itemProd.prodGrupo_GrupoNome}
                </MenuItem>
              ))}
            </Select>
          </InputLabel>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalEdit(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => putProducts(selectedProduct)}
          disabled={checkSaveBtn(selectedProduct)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
